import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import apiClient from '../../_utils/axios';
import { countBasketItem } from '../../_actions/userAction';
import images from '../../assets';
import {
  ContentsWrap,
  VerticalSp,
  HorizontalSp,
  RowCenter,
  HSLine,
  RowColum,
  ContentsArea,
  ModalContents,
  ModalTitle,
  MediaQuery,
  ModalNorBtn,
} from '../../components/Common';
import { RotatedImage } from '../../components/mypage/AIGenerateResult';
import { useTranslation } from 'react-i18next';
import Store from 'store';
import { useState, useEffect, useRef } from 'react';
import { CONFIG_MESSAGE } from '../../libs/config';
import { getCurrentLang } from '../../libs/lang';

export const LicensBlock = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 20px;
`;

export const DItemDowndload = styled.div`
  font-family: 'NSCJKrB';
  font-size: 14px;
  color: #ff8a06;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 30px;
  border: 1px solid #ff8a06;
  width: 98px;
  height: 34px;
  cursor: pointer;
`;

export const DItemDowndloadMobile = styled.div`
  font-family: 'NSCJKrB';
  font-size: 12px;
  color: #ff8a06;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 30px;
  border: 1px solid #ff8a06;
  width: 70px;
  height: 30px;
  cursor: pointer;
`;

export const DItemConverting = styled.div`
  font-family: 'NSCJKrB';
  font-size: 14px;
  color: #686868;
  background-color: #d9d9d9;
  border: 1px solid #d9d9d9;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 30px;
  width: 98px;
  height: 34px;
`;

export const DItemConvertingMobile = styled.div`
  font-family: 'NSCJKrB';
  font-size: 12px;
  color: #686868;
  background-color: #d9d9d9;
  border: 1px solid #d9d9d9;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 30px;
  width: 70px;
  height: 30px;
`;

export const LicenseType = ({ typetitle, filetype, typedes }) => {
  return (
    <>
      <img
        alt=""
        src={images.icon_license_act}
        style={{
          marginTop: 3,
        }}
      />
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          paddingTop: 20,
          paddingBottom: 20,
        }}
      >
        <HorizontalSp sp={10} />
        <div
          style={{
            flex: 1,
          }}
        >
          <div
            style={{
              fontFamily: 'NSCJKrM',
              fontSize: 16,
              color: 'black',
              lineHeight: '16px',
              display: 'flex',
            }}
          >
            <div> {typetitle} </div>
            <div
              style={{
                flex: 1,
              }}
            />
            <div> {filetype} </div>
          </div>
          <VerticalSp sp={8} />
          <div
            style={{
              fontFamily: 'NSCJKrR',
              fontSize: 14,
              color: '#666666',
              lineHeight: '14px',
              height: 14,
            }}
          >
            {typedes}
          </div>
        </div>
      </div>
    </>
  );
};

export const CustomButton = ({ onClick, style, children }) => {
  return (
    <div
      onClick={onClick}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '1px solid #fe8b07',
        borderRadius: 3,
        flex: 1,
        height: 62,
        fontFamily: 'NSCJKrM',
        fontSize: 21,
        color: '#ff8a06',
        cursor: 'pointer',
        ...style,
      }}
    >
      {children}
    </div>
  );
};

export const CartButton = ({ id, ShowBasketModal, style, children }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const onBasket = async () => {
    if (!Store.get('accessToken')) {
      alert(CONFIG_MESSAGE.REQUEST_LOGIN_MSG);
      return history.push('/auth');
    }

    const res = await apiClient.post(`/generate/cart/add/product/${id}`);

    if (res && res.status === 200) {
      ShowBasketModal();
      const result = await countBasketItem();
      if (result.status === 200) {
        dispatch({
          type: 'set',
          payload: {
            totalCartCount: result.data.totalCount,
          },
        });
      }
    } else {
    }
  };

  const lang = getCurrentLang();

  return (
    <div
      onClick={onBasket}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '1px solid #fe8b07',
        borderRadius: 3,
        flex: 1,
        height: 62,
        fontFamily: 'NSCJKrM',
        fontSize: lang === 'jp' ? 16 : 21,
        color: '#ff8a06',
        cursor: 'pointer',
        ...style,
      }}
    >
      {children}
    </div>
  );
};

export const CustomButtonMobile = ({ onClick, style, children }) => {
  return (
    <div
      onClick={onClick}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '1px solid #fe8b07',
        borderRadius: 3,
        flex: 1,
        height: 40,
        fontFamily: 'NSCJKrM',
        fontSize: 16,
        color: '#ff8a06',
        cursor: 'pointer',
        ...style,
      }}
    >
      {children}
    </div>
  );
};

export const ConvertBtn = ({
  item,
  t,
  onClick,
  convertingArray,
  downloadingArray,
  is_VirtualAccount_purchuage,
  style,
}) => {
  let button;
  const fontSize = Store.get('lang') === 'kr' ? 12 : 10;

  if (
    item.order_products &&
    item.order_products.length > 0 &&
    item.order_products.every((product) => product.is_download === true)
  ) {
    if (item.order_products.some((product) => product.is_convert === false)) {
      button = 'converting';
    } else {
      button = 'download';
    }
  } else {
    button = 'download';
  }
  // 변환 상태
  if (convertingArray.length > 0) {
    const includeArr = [];
    item.order_products.forEach((product) => {
      const included = convertingArray.map((item) => parseInt(item[0])).includes(product.product_id);
      includeArr.push(included); // 각 제품에 대한 포함 여부를 배열에 추가합니다.
    });

    // 구매 상품 전체가 다 변환 중일 때 버튼 변경
    const allIncluded = includeArr.every((value) => value === true);

    if (allIncluded) {
      button = 'converting';
    }
  }
  // 구매 상품 전체가 다 다운 중일 때 버튼 변경
  if (downloadingArray.length > 0) {
    const includeArr = [];
    item.order_products.forEach((product) => {
      const included = downloadingArray.map((item) => parseInt(item)).includes(product.product_id);
      includeArr.push(included);
    });
    const allIncluded = includeArr.every((value) => value === true);
    if (allIncluded) {
      button = 'downloading';
    }
  }

  return (
    <div>
      <MediaQuery min={600}>
        {button === 'converting' ? (
          <DItemConverting>
            <div style={{ width: 24, marginRight: 5 }}>
              <RotatedImage alt="" style={{ width: 24 }} src={images.img_generating2} />
            </div>
            {t('converting')}
          </DItemConverting>
        ) : (
          <>
            {button === 'downloading' ? (
              <DItemConverting>
                <div style={{ width: 24, marginRight: 5 }}>
                  <RotatedImage alt="" style={{ width: 24 }} src={images.img_generating2} />
                </div>
                {t('downloading')}
              </DItemConverting>
            ) : (
              <DItemDowndload
                onClick={is_VirtualAccount_purchuage ? null : onClick} // 가상계좌일 경우 클릭 이벤트 비활성화
                style={{
                  opacity: is_VirtualAccount_purchuage ? 0.5 : 1, // 가상계좌일 경우 시각적으로 비활성화
                  pointerEvents: is_VirtualAccount_purchuage ? 'none' : 'auto', // 마우스 이벤트 비활성화
                }}
              >
                {t('download')}
              </DItemDowndload>
            )}
          </>
        )}
      </MediaQuery>
      <MediaQuery max={599}>
        {button === 'converting' ? (
          <DItemConvertingMobile style={{ fontSize: fontSize }}>
            <div style={{ width: 18, marginRight: 3 }}>
              <RotatedImage alt="" style={{ width: 18 }} src={images.img_generating2} />
            </div>
            {t('converting')}
          </DItemConvertingMobile>
        ) : (
          <>
            {button === 'downloading' ? (
              <DItemConvertingMobile style={{ fontSize: fontSize }}>
                <div style={{ width: 18, marginRight: 3 }}>
                  <RotatedImage alt="" style={{ width: 18 }} src={images.img_generating2} />
                </div>
                {t('downloading')}
              </DItemConvertingMobile>
            ) : (
              <DItemDowndloadMobile
                onClick={is_VirtualAccount_purchuage ? null : onClick}
                style={{
                  fontSize: fontSize,
                  opacity: is_VirtualAccount_purchuage ? 0.5 : 1,
                  pointerEvents: is_VirtualAccount_purchuage ? 'none' : 'auto',
                }}
              >
                {t('download')}
              </DItemDowndloadMobile>
            )}
          </>
        )}
      </MediaQuery>
    </div>
  );
};

export const ConvertBtnEach = ({
  item,
  t,
  onClick,
  convertingArray,
  downloadingArray,
  style,
  setList,
  list,
  productIndex,
  index,
  is_VirtualAccount_purchuage,
}) => {
  const intervalRef = useRef(null); // 타이머를 저장할 Ref
  const hasValidList =
    !intervalRef.current &&
    list &&
    list[index] &&
    list[index].order_products &&
    list[index].order_products[productIndex] &&
    list[index].order_products[productIndex].convertPercent;
  const [convertStep, setConvertStep] = useState(0);
  const [convertPercent, setConvertPercent] = useState(hasValidList ? hasValidList : 0);
  const [button, setButton] = useState('download');
  const [downloading, setDownloading] = useState(0);
  const fontSize = Store.get('lang') === 'kr' ? 12 : 10;
  const downloadItem = downloadingArray.find((dItem) => parseInt(dItem[0]) === item.product_id);
  const convItem = convertingArray.find((convItem) => parseInt(convItem[0]) === item.product_id);
  const convertPercentRef = useRef(hasValidList ? hasValidList : 0);

  const convertStateChecker = () => {
    if (!intervalRef.current) {
      intervalRef.current = setInterval(() => {
        if (convItem && convertPercent < convertStep * 20 + 20 && convertPercent < 100) {
          convertPercentRef.current = convertPercentRef.current + 1;
          setList(productIndex, index, convertPercentRef.current);
          setConvertPercent(convertPercentRef.current); // 상태 업데이트는 반드시 이전 상태값을 기반으로
        }
      }, 1000);
    }
  };
  // console.log('hasValidList: ', hasValidList);
  // 변환 상태 확인 및 버튼 상태 업데이트
  useEffect(() => {
    if (convItem) {
      setButton('converting');
      setConvertStep(convItem[1]);
      if (convertPercent < convItem[1] * 20) {
        convertPercentRef.current = convItem[1] * 20;
        setConvertPercent(convItem[1] * 20);
      }
      // // 상태 업데이트
      if (!intervalRef.current) {
        convertStateChecker();
      }
    } else {
      // convItem이 없을 때 타이머 정리
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }

      // 버튼 상태 업데이트
      if (item) {
        if (item.is_download === false && item.is_convert === false) {
          setButton('download');
        } else if (item.is_download === false && item.is_convert === true) {
          setButton('download');
        } else if (item.is_download === true && item.is_convert === true) {
          setButton('download');
        }
      }
    }

    // 컴포넌트 언마운트 시 타이머 정리
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
      // 상태를 직접 수정하지 않고 새로운 배열로 복사
    };
  }, [convertingArray, item, convItem]);

  // 다운로드 상태 확인 및 버튼 상태 업데이트
  useEffect(() => {
    if (downloadItem && !convItem) {
      setButton('downloading');
      setDownloading(downloadItem[1]);
    } else if (!convItem && !downloadItem) {
      setButton('download');
    }
  }, [downloadingArray, item]);

  return (
    <>
      <MediaQuery min={600}>
        {button === 'converting' ? (
          <DItemConverting>
            <div style={{ width: 24, marginRight: 5 }}>
              <RotatedImage alt="" style={{ width: 24 }} src={images.img_generating2} />
            </div>
            {convertPercent}%
          </DItemConverting>
        ) : button === 'downloading' ? (
          <DItemConverting>
            <div style={{ width: 24, marginRight: 5 }}>
              <RotatedImage alt="" style={{ width: 24 }} src={images.img_generating2} />
            </div>
            {downloading}%
          </DItemConverting>
        ) : (
          <DItemDowndload
            onClick={is_VirtualAccount_purchuage ? null : onClick}
            style={{
              opacity: is_VirtualAccount_purchuage ? 0.5 : 1, // 가상계좌일 경우 시각적으로 비활성화
              pointerEvents: is_VirtualAccount_purchuage ? 'none' : 'auto', // 마우스 이벤트 비활성화
            }}
          >
            {t('download')}
          </DItemDowndload>
        )}
      </MediaQuery>

      <MediaQuery max={599}>
        {button === 'converting' ? (
          <DItemConvertingMobile style={{ fontSize }}>
            <div style={{ width: 18, marginRight: 3 }}>
              <RotatedImage alt="" style={{ width: 18 }} src={images.img_generating2} />
            </div>
            {convertPercent}%
          </DItemConvertingMobile>
        ) : button === 'downloading' ? (
          <DItemConvertingMobile style={{ fontSize }}>
            <div style={{ width: 18, marginRight: 3 }}>
              <RotatedImage alt="" style={{ width: 18 }} src={images.img_generating2} />
            </div>
            {downloading}%
          </DItemConvertingMobile>
        ) : (
          <DItemDowndloadMobile
            onClick={is_VirtualAccount_purchuage ? null : onClick}
            style={{
              fontSize,
              opacity: is_VirtualAccount_purchuage ? 0.5 : 1,
              pointerEvents: is_VirtualAccount_purchuage ? 'none' : 'auto',
            }}
          >
            {t('download')}
          </DItemDowndloadMobile>
        )}
      </MediaQuery>
    </>
  );
};
